"use strict";
/**
 * Google Contacts Sync - Response Types
 *
 * Response contracts for the Google Contacts sync feature.
 * Used by frontend to display sync status and results.
 *
 * @example GET /api/google-contacts/status
 * @example GET /api/google-contacts/oauth/status
 */
Object.defineProperty(exports, "__esModule", { value: true });
